var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 2.875H14.75V1.125C14.75 0.892936 14.6578 0.670376 14.4937 0.506282C14.3296 0.342187 14.1071 0.25 13.875 0.25C13.6429 0.25 13.4204 0.342187 13.2563 0.506282C13.0922 0.670376 13 0.892936 13 1.125V2.875H6V1.125C6 0.892936 5.90781 0.670376 5.74372 0.506282C5.57962 0.342187 5.35707 0.25 5.125 0.25C4.89294 0.25 4.67038 0.342187 4.50628 0.506282C4.34219 0.670376 4.25 0.892936 4.25 1.125V2.875H3.375C2.67881 2.875 2.01113 3.15156 1.51884 3.64385C1.02656 4.13613 0.75 4.80381 0.75 5.5V6.375H18.25V5.5C18.25 4.80381 17.9734 4.13613 17.4812 3.64385C16.9889 3.15156 16.3212 2.875 15.625 2.875Z",
    fill: "#F35D1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.125C0.75 15.8212 1.02656 16.4889 1.51884 16.9812C2.01113 17.4734 2.67881 17.75 3.375 17.75H15.625C16.3212 17.75 16.9889 17.4734 17.4812 16.9812C17.9734 16.4889 18.25 15.8212 18.25 15.125V8.125H0.75V15.125Z",
    fill: "#F35D1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience_icon.c809f8e694db035155be03bcf3d5afe2.svg";
export { ForwardRef as ReactComponent };